'use client';

import Link from 'next/link';

import { getFooterImages } from './helpers';
import { ImageComponent } from '@/components/Image';
import { Country } from '@/helpers/conf';
import useEstonia from '@/hooks/estonia';
import { useCurrentCountry } from '@/hooks/useCurrentCountry';

export const FooterImages = () => {
  const { isEstonia } = useEstonia();
  const isAustralia = useCurrentCountry(Country.Australia);
  const footerImages = getFooterImages(isEstonia, isAustralia);

  return footerImages.map(({ href, alt, isHidden, ...props }, index) =>
    isHidden ? null : href ? (
      <Link
        key={index}
        href={href}
        target="_blank"
        rel="noreferrer"
        aria-label={alt}
      >
        <ImageComponent {...props} alt={alt} />
      </Link>
    ) : (
      <ImageComponent key={index} {...props} alt={alt} />
    )
  );
};
